import { render, staticRenderFns } from "./contentExamReport.vue?vue&type=template&id=389f03c2&"
import script from "./contentExamReport.vue?vue&type=script&lang=js&"
export * from "./contentExamReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports